import React, { useCallback, useEffect, useState } from 'react'
import { mergeLeft } from 'ramda'
import { useIntl } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'

import { useIsOnline } from 'commons/useIsOnline'
import NetworkError from 'app/components/NetworkError'

import { ReactComponent as EmptyMessageIcon } from 'app/components/icons/empty-message-icon.svg'

import EmptyState from 'app/componentV4/EmptyState'
import PanelPages from 'app/componentV4/Panels/Pages'
import DataTable from 'app/componentV4/Table/DataTable'
import PanelFilter from 'app/componentV4/Panels/Filter'
import ButtonFilter from 'app/componentV4/Filters/ButtonFilter'
import CalendarSelector from 'app/componentV4/Filters/CalendarSelector'

import ViewDetail from './ViewDetail'
import { filters } from 'app/main/plansAndBilling/constants'
import useAiUsageLog from 'app/main/plansAndBilling/aiUsageLog/useAiUsageLog'
import { ColumnOfData } from 'app/main/plansAndBilling/aiUsageLog/ColumnOfData'

const useStyles = makeStyles((theme) => ({
  table: {
    '&.data-table': {
      [theme.breakpoints.up('md')]: {
        height: 'calc(100vh - 188px)',
      },
    },
  },
}))

const AIUsageHistory = ({ location }) => {
  const [isOnline] = useIsOnline()
  const classes = useStyles()
  const { formatMessage } = useIntl()
  const listFilters = filters(formatMessage)

  const [isOpen, setIsOpen] = useState(false)
  const [selectedRow, setSelectedRow] = useState(null)

  const {
    state: {
      params,
      filter,
      dateRang,
      aiCreditDetail,
      isLoading,
      aiUsageLog,
      isEmptyAiUsageLog,
      isLoadingLogDetail,
      // filterStatus,
    },
    handleFilter,
    handleDateFilter,
    // handleFilterStatus,
    handleFetchAiUsageLog,
    handleFetchAiLogDetail,
  } = useAiUsageLog()
  const { data, meta } = aiUsageLog

  const handleOpenDetail = async (data) => {
    setSelectedRow(data)
    setIsOpen(true)
    await handleFetchAiLogDetail(data.requestId)
  }

  const fetchFirstAiUsageLog = useCallback(() => {
    handleFetchAiUsageLog(params, true)
  }, [handleFetchAiUsageLog, params])

  useEffect(fetchFirstAiUsageLog, [])

  if (!isOnline) {
    return <NetworkError onRetryFetching={() => {}} />
  }

  return (
    <PanelPages
      isEmptyState={isEmptyAiUsageLog}
      emptyState={
        <EmptyState
          icon={<EmptyMessageIcon />}
          title={formatMessage({
            id: 'aiUsageLog.empty.title',
          })}
          description={formatMessage({
            id: 'aiUsageLog.empty.description',
          })}
          accesses={[]}
        />
      }
      title={formatMessage({
        id: 'navigation.planAndBilling.aiUsageLog.label',
      })}
    >
      <PanelFilter
        leftContent={
          <>
            <CalendarSelector
              id="usage-log-filterDate"
              name="filterDate"
              values={dateRang}
              className="mr-5 mt-5"
              label={formatMessage({ id: 'text.dates' })}
              onChange={handleDateFilter}
              disabled={isLoading}
            />
            {listFilters.map((list) => (
              <ButtonFilter
                key={list.key}
                id={list.label}
                label={list.label}
                className="my-3 md:my-0 mx-3 bg-primary-200 text-primary text-14"
                onClick={() => handleFilter(list.key)}
                isActive={list.key === filter}
                disabled={isLoading}
              />
            ))}
            {/* <CheckboxSelector
              name="filterStatus"
              label={formatMessage({ id: 'message.status.label' })}
              values={filterStatus}
              onChange={(value) => {
                handleFilterStatus(value)
              }}
              className="mr-5 bg-primary-200 text-primary text-14 font-normal"
              disabled={isLoading}
            /> */}
          </>
        }
      />
      <DataTable
        data={data}
        className={classes.table}
        columns={ColumnOfData(formatMessage)}
        pagination={meta}
        isLoading={isLoading}
        onFetch={(value) => {
          handleFetchAiUsageLog(mergeLeft(value, params))
        }}
        onSelectedRow={(data) => handleOpenDetail(data)}
        activeRow={selectedRow?.alertId}
      />
      {isOpen ? (
        <ViewDetail
          isOpen={isOpen}
          detail={aiCreditDetail}
          isLoading={isLoadingLogDetail}
          onClose={() => {
            setIsOpen(false)
            setSelectedRow(null)
          }}
        />
      ) : null}
    </PanelPages>
  )
}

export default AIUsageHistory
